import React from 'react'
import { isMobile, isTablet } from "react-device-detect";
import PropTypes from 'prop-types';

const Video = props => {

    const { urlVideo } = props;
    var width = 610;
    var height = 343;

    if(isMobile){       
        width = 340; 
        height = 220;
    }
    if(isTablet){
        width = 610;
        height = 343;
    }

    return (
        <article className="position-relative mt-2 mt-md-0 mb-md-5 text-center"
            dangerouslySetInnerHTML={{ __html: `<iframe width="${width}" height="${height}" src="${urlVideo}" />` }} 
        />
    )
}

export default Video;

Video.propTypes = {
    urlVideo: PropTypes.string.isRequired
}